import React from 'react';
import PropTypes from 'prop-types';

import LanguageSelect from './LanguageSelect';

// The language switcher in the site headers (it used to sit in the footer,
// where the chat button covered it). One per header slot, each with its own id.
const HeaderLanguage = ({ variant }) => (
  <div className={`bm-header-language bm-header-language--${variant}`}>
    <LanguageSelect id={`bm-header-language-${variant}`} />
  </div>
);
HeaderLanguage.propTypes = { variant: PropTypes.string.isRequired };

export const DesktopHeaderLanguage = () => <HeaderLanguage variant="desktop" />;
export const MobileHeaderLanguage = () => <HeaderLanguage variant="mobile" />;
export const LearningHeaderLanguage = () => <HeaderLanguage variant="learning" />;
export const StudioHeaderLanguage = () => <HeaderLanguage variant="studio" />;
